import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ConfirmDialogService } from '../../../services/confirm-dialog';
import { LanguageService } from '../../../services/i18n/language';

/** Окно подтверждения/сообщения для всего сайта (см. ConfirmDialogService). */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();

  constructor(
    public dialog: ConfirmDialogService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(this.dialog.changed$.subscribe(() => this.cdr.markForCheck()));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  t(key: string, fallback: string): string {
    const value = this.languageService.translate(key);
    return value && value !== key ? value : fallback;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.dialog.state) {
      this.dialog.close(false);
    }
  }
}
